<ng-container>{{data[fieldName] ? (data[fieldName] | currency:'USD':'symbol':'1.2-2') : '-'}}</ng-container>
